<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Gerador de Assinaturas</h3>
        </div>
      </div>
      <div class="col-md-6 text-center text-sm-left card-signature">
        <d-card class="card">
          <d-card-body>
            <!-- Name -->
            <d-form-row>
              <d-col md="12" class="form-group">
                <label>Nome</label>
                <d-form-input
                  type="text"
                  placeholder="Nome"
                  v-model="infoSignature.Name"
                />
              </d-col>
            </d-form-row>
            <!-- Occupation -->
            <d-form-row>
              <d-col md="12" class="form-group">
                <label>Cargo</label>
                <d-form-input
                  type="text"
                  placeholder="Cargo"
                  v-model="infoSignature.Occupation"
                />
              </d-col>
            </d-form-row>
            <!-- Phone -->
            <d-form-row>
              <d-col md="12">
                <label>Telefone</label>
                <d-input-group seamless>
                  <d-input-group-text slot="prepend">
                    <i class="fas fa-phone-alt"></i>
                  </d-input-group-text>
                  <the-mask
                    class="form-control"
                    type="tel"
                    :mask="['(##) #####-####', '(##) ####-####']"
                    placeholder="Telefone"
                    v-model="infoSignature.Phone"
                  />
                </d-input-group>
              </d-col>
            </d-form-row>
          </d-card-body>
          <!-- Button -->
          <d-card-footer>
            <b-button
              variant="primary"
              class="float-left"
              v-b-tooltip.hover.bottom
              title="Limpar"
              @click="Reset()"
              :disabled="loading || loadingSpecial"
            >
              <i class="fas fa-eraser"></i>
            </b-button>
            <b-button
              variant="primary"
              class="float-right ml-2"
              @click="GetSignature()"
              :disabled="loading"
            >
              <template v-if="!loading">
                Gerar
                <i class="fas fa-arrow-right"></i>
              </template>
              <template v-else>
                <loader
                  :small="true"
                  :labelEnabled="false"
                  :isLoading="loading"
                ></loader>
              </template>
            </b-button>
            <b-button
              variant="primary"
              class="float-right"
              @click="GetSignature(true)"
              :disabled="loadingSpecial"
            >
              <template v-if="!loadingSpecial">
                Gerar especial
                <i class="fas fa-arrow-right"></i>
              </template>
              <template v-else>
                <loader
                  :small="true"
                  :labelEnabled="false"
                  :isLoading="loadingSpecial"
                ></loader>
              </template>
            </b-button>
          </d-card-footer>
        </d-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "signatures",
  components: {},
  data: function () {
    return {
      loading: false,
      loadingSpecial: false,
      infoSignature: {
        Name: null,
        Occupation: null,
        Phone: null,
        IsSpecial: false,
      },
    };
  },
  computed: {},
  mounted() {
    this.GetUserInternalInfo();
  },
  methods: {
    Reset: function () {
     this.infoSignature = {
        Name: null,
        Occupation: null,
        Phone: null
      };
    },
    GetUserInternalInfo: function () {
      let userInternal = this.$getUserInternal();
      this.infoSignature = {
        Name: this.$options.filters.capitalizeWords(
          this.$options.filters.lower(userInternal.Name)
        ),
        Occupation: userInternal.Occupation,
        Phone: userInternal.Phone,
      };
    },
    GetSignature: function (isSpecial = false) {
      if (isSpecial) this.loadingSpecial = true;
      else this.loading = true;
      this.infoSignature.IsSpecial = isSpecial;
      this.$store
        .dispatch("GetSignature", this.infoSignature)
        .then((response) => {
          if (
            response.UrlSignature != null &&
            response.UrlSignature != undefined &&
            response.UrlSignature != ""
          ) {
            window.open(response.UrlSignature, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao gerar a assinatura",
            error
          );
        })
        .finally(() => {
          if (isSpecial) this.loadingSpecial = false;
          else this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.card-signature {
  padding-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/signatures.vue